var _path, _path2, _path3, _path4, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCqdgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 40,
    viewBox: "0 0 71 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1062 23.9521C42.7432 24.4948 42.2509 24.9373 41.6742 25.2392C41.0975 25.5412 40.4548 25.6929 39.8048 25.6806C37.3288 25.6806 34.9707 23.7318 34.9707 20.1799V20.1392C34.9707 16.5805 37.285 14.6317 39.7947 14.6317C40.4305 14.6187 41.0605 14.7561 41.6339 15.0328C42.2073 15.3095 42.7081 15.7177 43.0961 16.2246V14.8249H46.101V28.653H43.0961L43.1062 23.9521ZM43.1466 20.1731V20.1324C43.1466 18.3633 41.9776 17.1906 40.5763 17.1906C39.1749 17.1906 37.9857 18.3429 37.9857 20.1324V20.1799C37.9857 21.9491 39.1715 23.1217 40.5763 23.1217C41.981 23.1217 43.1466 21.9423 43.1466 20.1799V20.1731Z",
    fill: "#008FC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1387 20.1797V20.1391C47.1387 16.5804 49.4496 14.6315 51.9593 14.6315C52.5952 14.6183 53.2252 14.7556 53.7986 15.0323C54.3721 15.309 54.8729 15.7173 55.2607 16.2245V10.9678H58.2656V25.4839H55.2607V23.952C54.8977 24.4946 54.4054 24.9371 53.8287 25.2391C53.252 25.541 52.6093 25.6928 51.9593 25.6805C49.49 25.6805 47.1387 23.7316 47.1387 20.1797ZM55.3011 20.1797V20.1391C55.3011 18.3699 54.1355 17.1972 52.7308 17.1972C51.326 17.1972 50.1402 18.3495 50.1402 20.1391V20.1797C50.1402 21.9489 51.3294 23.1216 52.7308 23.1216C54.1321 23.1216 55.3011 21.9421 55.3011 20.1797Z",
    fill: "#008FC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8251 27.589L60.856 25.3249C61.9369 25.9709 63.1729 26.3073 64.4302 26.2977C66.4885 26.2977 67.462 25.3046 67.462 23.3965V22.8915C66.5727 23.9659 65.6059 24.62 64.0023 24.62C61.5331 24.62 59.2861 22.8101 59.2861 19.6514V19.6107C59.2861 16.4282 61.56 14.6387 64.0023 14.6387C64.6552 14.6247 65.3026 14.761 65.8952 15.0371C66.4878 15.3131 67.0098 15.7217 67.4216 16.2316V14.8251H70.4265V23.0779C70.4265 24.986 69.9717 26.379 69.079 27.2738C68.092 28.2668 66.5693 28.704 64.5144 28.704C62.8844 28.7215 61.2748 28.3388 59.8251 27.589ZM67.4553 19.6378V19.5971C67.4553 18.1465 66.3301 17.1298 64.8647 17.1298C63.3993 17.1298 62.2978 18.1465 62.2978 19.5971V19.6378C62.2978 21.1087 63.4027 22.1018 64.8647 22.1018C66.3268 22.1018 67.4553 21.0884 67.4553 19.6378Z",
    fill: "#008FC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8839 9.27932C34.5624 5.6231 31.1167 2.81929 27.0649 1.28938C23.0131 -0.240521 18.5742 -0.413834 14.4155 0.795498C10.2567 2.00483 6.60293 4.53145 4.00336 7.99553C1.40379 11.4596 -0.00106362 15.6739 6.03794e-07 20.0049C0.00106483 24.3359 1.40799 28.5495 4.00926 32.0123C6.61053 35.4751 10.2656 38 14.4249 39.2072C18.5842 40.4145 23.0231 40.239 27.0741 38.7071C31.1251 37.1752 34.5694 34.3697 36.8892 30.7124L33.1736 28.3557C31.3642 31.2084 28.6776 33.3967 25.5178 34.5916C22.358 35.7864 18.8957 35.9233 15.6514 34.9817C12.4071 34.04 9.55621 32.0706 7.52722 29.3696C5.49823 26.6686 4.40083 23.382 4.4 20.0038C4.39917 16.6257 5.49496 13.3385 7.52262 10.6365C9.55028 7.93453 12.4002 5.96377 15.6441 5.02049C18.8879 4.07721 22.3502 4.21239 25.5106 5.40572C28.671 6.59904 31.3586 8.78602 33.1695 11.6379L36.8839 9.27932Z",
    fill: "#008FC7"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2392_38364)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2392_38364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0101,
    cy: 20.0101,
    r: 11.9456,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2392_38364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8457 12.0797C14.5568 12.0797 15.1332 11.4997 15.1332 10.7844C15.1332 10.069 14.5568 9.48902 13.8457 9.48902C13.1346 9.48902 12.5582 10.069 12.5582 10.7844C12.5582 11.4997 13.1346 12.0797 13.8457 12.0797Z",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.791,
    y: 11.0127,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 11.791 11.0127)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.99707,
    y: 15.8066,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 6.99707 15.8066)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9229,
    y: 1.88086,
    width: 2.58284,
    height: 9.68565,
    rx: 1.29142,
    transform: "rotate(45 20.9229 1.88086)",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82324 22.1246C9.53431 22.1246 10.1107 21.5447 10.1107 20.8293C10.1107 20.1139 9.53431 19.5339 8.82324 19.5339C8.11218 19.5339 7.53575 20.1139 7.53575 20.8293C7.53575 21.5447 8.11218 22.1246 8.82324 22.1246Z",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6182,
    y: 14.208,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 13.6182 14.208)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5859,
    y: 11.2402,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 16.5859 11.2402)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3799,
    y: 6.44629,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 21.3799 6.44629)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.76855,
    y: 21.0576,
    width: 2.58284,
    height: 7.74852,
    rx: 1.29142,
    transform: "rotate(45 6.76855 21.0576)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.042 18.9283C17.7531 18.9283 18.3295 18.3484 18.3295 17.633C18.3295 16.9176 17.7531 16.3376 17.042 16.3376C16.3309 16.3376 15.7545 16.9176 15.7545 17.633C15.7545 18.3484 16.3309 18.9283 17.042 18.9283Z",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5117,
    y: 2.33691,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 30.5117 2.33691)",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.9873,
    y: 17.8613,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 14.9873 17.8613)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.0098,
    y: 12.8389,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 20.0098 12.8389)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1934,
    y: 22.6553,
    width: 2.58284,
    height: 9.68565,
    rx: 1.29142,
    transform: "rotate(45 10.1934 22.6553)",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7178,
    y: 7.13086,
    width: 2.58284,
    height: 7.74852,
    rx: 1.29142,
    transform: "rotate(45 25.7178 7.13086)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2158 25.777C15.9269 25.777 16.5033 25.197 16.5033 24.4816C16.5033 23.7662 15.9269 23.1863 15.2158 23.1863C14.5048 23.1863 13.9283 23.7662 13.9283 24.4816C13.9283 25.197 14.5048 25.777 15.2158 25.777Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.0869,
    y: 10.7842,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 27.0869 10.7842)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1611,
    y: 24.71,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 13.1611 24.71)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.293,
    y: 15.5781,
    width: 2.58284,
    height: 9.68565,
    rx: 1.29142,
    transform: "rotate(45 22.293 15.5781)",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.22559,
    y: 30.6455,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 7.22559 30.6455)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1934,
    y: 27.6777,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 10.1934 27.6777)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0205 33.9957C12.7316 33.9957 13.308 33.4158 13.308 32.7004C13.308 31.985 12.7316 31.405 12.0205 31.405C11.3094 31.405 10.733 31.985 10.733 32.7004C10.733 33.4158 11.3094 33.9957 12.0205 33.9957Z",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5342,
    y: 7.35938,
    width: 2.58284,
    height: 7.74852,
    rx: 1.29142,
    transform: "rotate(45 35.5342 7.35938)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.9883,
    y: 27.9062,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 14.9883 27.9062)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8271,
    y: 13.0664,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 29.8271 13.0664)",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8594,
    y: 16.0342,
    width: 2.58284,
    height: 9.68565,
    rx: 1.29142,
    transform: "rotate(45 26.8594 16.0342)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7822,
    y: 23.1113,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 19.7822 23.1113)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9463 25.0924C26.6574 25.0924 27.2338 24.5124 27.2338 23.797C27.2338 23.0817 26.6574 22.5017 25.9463 22.5017C25.2352 22.5017 24.6588 23.0817 24.6588 23.797C24.6588 24.5124 25.2352 25.0924 25.9463 25.0924Z",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.8145,
    y: 31.1016,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 16.8145 31.1016)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.9141,
    y: 19.002,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 28.9141 19.002)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8916,
    y: 24.0244,
    width: 2.58284,
    height: 9.68565,
    rx: 1.29142,
    transform: "rotate(45 23.8916 24.0244)",
    fill: "#A8AD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.708,
    y: 14.208,
    width: 2.58284,
    height: 6.4571,
    rx: 1.29142,
    transform: "rotate(45 33.708 14.208)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.6523,
    y: 21.2852,
    width: 2.58284,
    height: 7.74852,
    rx: 1.29142,
    transform: "rotate(45 31.6523 21.2852)",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.9453,
    y: 26.9922,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 25.9453 26.9922)",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.6201,
    y: 18.3174,
    width: 2.58284,
    height: 3.87426,
    rx: 1.29142,
    transform: "rotate(45 34.6201 18.3174)",
    fill: "#C54B38"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.9775,
    y: 29.96,
    width: 2.58284,
    height: 9.68565,
    rx: 1.29142,
    transform: "rotate(45 22.9775 29.96)",
    fill: "#00AEEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2392_38364"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.06445,
    y: 8.06445,
    width: 23.871,
    height: 23.871,
    rx: 11.9355,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCqdgLogo);
export default __webpack_public_path__ + "static/media/cqdg-logo.a7adcad2f6dceda36e675bef7473fa78.svg";
export { ForwardRef as ReactComponent };